import React, { Component } from "react";
import CircularJSON from "circular-json";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import NuxeoClient from "../../clients/NuxeoClient";
import StringUtils from "../../utils/StringUtils";
import EventUtils from "../../utils/EventUtils";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Loading from "../loading/Loading";
import ArrayUtils from "../../utils/ArrayUtils";

import AddProductModal from "../ui/AddProductModal";
import Table from "../ui/Table";
import { FavMenu } from "../ui/FavMenu";
import SnackBar from "../ui/SnackBar";
import { JobLoadingModal } from "../ui/Modals";
import Licensee from "../inputs/Licensee";
import Contract from "../inputs/Contract";
import Territories from "../inputs/Territories";
import Property from "../inputs/Property";
import ConsumerTarget from "../inputs/ConsumerTarget";
import Date from "../inputs/Date";
import Text from "../inputs/Text";
import AssociatedJobs from "../inputs/AssociatedJobs";
import LineSheet from "../inputs/LineSheet";
import SubmissionType from "../inputs/SubmissionType";
import DeliveryType from "../inputs/DeliveryType";
import Autocomplete from "../ui/Autocomplete";

import "../../css/submissionFields.css";
import { GAPageView } from "../..";
import ReactGA from "react-ga";

import { I18nContext } from "../../I18nProvider";

export class GTESubmissionFields extends Component {
  static contextType = I18nContext;
  constructor(props) {
    super(props);

    //Defain the component state
    this.state = {
      isSoldInPackage: false,
      isSoldInSet: false,
      isDigitalContent: false,
      isPlush: false,
      areFilesUploading: false,
      areSupportingFilesUploading: false,
      areLineSheetFilesUploading: false,
      isJobInfoLoading: false,
      isSubmitting: false,
      requiredFields: [
        "licensee",
        "contract",
        "territories",
        "property",
        "submissionType",
        "location",
        "consumerTarget",
        "modalSubmitData",
        "deliveryType",
        "targetAudience",
        "inMarketStartDate",
        "inMarketEndDate",
      ],
      modalrequiredFields: [
        "licenseeRef",
        "productDetail",
        "assetFileName",
        "characters",
        "files",
      ],

      licensee: null,
      licenseeID: null,
      licenseePath: null,
      licenseeCode: null,
      contract: "",
      contractID: null,
      territories: [],
      territoriesID: [],
      property: "",
      propertyID: null,
      tierOfDistribution: [],
      retailer: [],
      consumerTarget: [],
      season: [],
      onShelfDate: null,
      inMarketStartDate: null,
      inMarketEndDate: null,
      productTitle: "",
      additionalNotes: "",
      associatedJobs: [],
      associatedJobsID: [],
      licenseeRef: null,
      productDetail: null,
      productDetailID: null,
      assetFileName: [],
      assetFileID: null,
      originalAssetsUID: [],
      originalAssetsParentRef: [],
      characters: [],
      charactersID: [],
      text: "",
      name: [],
      inMarketSeason: null,
      submissionType: "",
      deliveryType: "",
      location: [],
      locationProduct: [],
      area: [],
      areaProduct: [],
      attraction: [],
      attractionProduct: [],
      submissionNumber: "",
      item: "",
      itemType: "",
      originalSeason: "",
      originalAssetSeasonID: null,
      pricePointUSD: null,
      lineSheetRef: "",
      targetAudience: "",
      isFavorite: false,
      favoriteName: null,

      //dropzone state variables
      supportingFilesOpen: false,
      filesOpen: false,
      lineSheetFilesOpen: false,
      files: [],
      supportingFiles: [],
      lineSheetFiles: null,
      filesBatch: null,
      supportingFilesBatch: [],
      lineSheetFilesBatch: [],

      //data-fetching state variables
      fetchedLicensees: [],
      fetchedProperty: [],
      fetchedAssetFileNames: [],
      fetchedAssetFileCharacters: [],
      fetchedMarketingChannels: [],
      fetchedLocations: [],
      fetchedAreas: [],
      fetchedAttractions: [],
      fetchedItemType: [],
      fetchedOriginalSeasons: [],

      //modal variables
      modalSubmitData: [],
      editData: null,
      editIndex: null,
      modalOpened: false,
      resetModal: true,
      editModal: false,

      areLocationsLoading: true,
      areAreasLoading: true,
      areSubmissionsLoading: true,
      areDeliveriesLoading: true,
      areAttractionsLoading: true,

      //snackbar
      openSnackMsg: false,
      snackBarMsg: "Sample Msg",
    };
    this.docPrefix = "gte";
    this.docType = "SubmissionGTE";
    this.document = null;

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRemoveFile = this.handleRemoveFile.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.setJobInfo = this.setJobInfo.bind(this);
  }

  //fetching dropdown data from Nuxeo
  async componentDidMount() {
    await this._createEmptyDoc();
    await this._loadLocations();
    await this._loadAreas();
    await this._loadAttractions();
    await this._loadItemType();
    GAPageView("GTE Submission Form");
  }

  setJobInfo(jobInfo) {
    this.setState({ isJobInfoLoading: true });
    this.clearValues();

    this.setState({ contractID: jobInfo["submission:contract"] });
    this._getInfoById(jobInfo["submission:contract"]).then((res) =>
      this.setState({ contract: res.title }, () =>
        this._checkFieldChange("contract")
      )
    );

    this.setState({ territoriesID: jobInfo["submission:territories"] });
    jobInfo["submission:territories"].forEach((territory, index) => {
      this._getInfoById(territory).then((response) => {
        let territories = [...this.state.territories];
        territories.push(response.title);
        this.setState({ territories });
      });
    });

    this.setState({ propertyID: jobInfo["submission:property"] });
    this._getInfoById(jobInfo["submission:property"]).then((response) => {
      this.setState({ property: response.title }, () =>
        this._checkFieldChange("property")
      );
    });

    this.setState({ associatedJobsID: jobInfo["submission:associatedJobs"] });
    jobInfo["submission:associatedJobs"].forEach((id) => {
      this._getInfoById(id).then((response) => {
        let associatedJobs = [...this.state.associatedJobs];
        associatedJobs.push(response.title);
        this.setState({ associatedJobs });
      });
    });

    let location = [...this.state.location];
    jobInfo["gte_submission:location"].forEach((id) => {
      this.state.fetchedLocations.forEach((data) => {
        if (data.uid === id) {
          location.push(data.title);
        }
      });
    });
    this.setState({ location });

    let attraction = [...this.state.attraction];
    jobInfo["gte_submission:attraction"].forEach((id) => {
      this.state.fetchedAttractions.forEach((data) => {
        if (data.uid === id) {
          attraction.push(data.title);
        }
      });
    });
    this.setState({ attraction });

    let area = [...this.state.area];
    jobInfo["gte_submission:area"].forEach((id) => {
      this.state.fetchedAreas.forEach((data) => {
        if (data.uid === id) {
          area.push(data.title);
        }
      });
    });
    this.setState({ area });

    let productsArray = jobInfo[this.docPrefix + "_submission:product"];
    let modalSubmitData = [];
    for (var i = 0; i < productsArray.length; i++) {
      modalSubmitData[i] = this.getModalSubmitData();
    }
    productsArray.forEach((product, index) => {
      let location = [];
      product["gte_location"].forEach((id) => {
        this.state.fetchedLocations.forEach((data) => {
          if (data.uid === id) {
            location.push(data.title);
          }
        });
      });
      modalSubmitData[index].location = location;

      let attraction = [];
      product["gte_attraction"].forEach((id) => {
        this.state.fetchedAttractions.forEach((data) => {
          if (data.uid === id) {
            attraction.push(data.title);
          }
        });
      });
      modalSubmitData[index].attraction = attraction;

      let area = [];
      product["gte_area"].forEach((id) => {
        this.state.fetchedAreas.forEach((data) => {
          if (data.uid === id) {
            area.push(data.title);
          }
        });
      });
      modalSubmitData[index].area = area;

      product[this.docPrefix + "_originalAssets"].forEach((asset) => {
        this._getInfoById(asset, index).then((response) => {
          var assetsArray = [...modalSubmitData[response.index].assetFileName];
          assetsArray.push(response.title);
          modalSubmitData[response.index].assetFileName = assetsArray;
        });
      });

      product[this.docPrefix + "_characters"].forEach((character) => {
        this._getInfoById(character, index).then((response) => {
          var charactersArray = [...modalSubmitData[response.index].characters];
          charactersArray.push(response.title);
          modalSubmitData[response.index].characters = charactersArray;
        });
      });
      modalSubmitData[index].charactersID =
        product[this.docPrefix + "_characters"];

      if (product[this.docPrefix + "_productDetail"]) {
        modalSubmitData[index].productDetailID =
          product[this.docPrefix + "_productDetail"];
        this._getInfoById(
          product[this.docPrefix + "_productDetail"],
          index
        ).then(
          (response) =>
            (modalSubmitData[response.index].productDetail = response.title)
        );
      }

      modalSubmitData[index].licenseeRef = product[
        this.docPrefix + "_internalRefId"
      ]
        ? product[this.docPrefix + "_internalRefId"]
        : "";
      modalSubmitData[index].text_verbiage = product[
        this.docPrefix + "_assetTextVerbiage"
      ]
        ? product[this.docPrefix + "_assetTextVerbiage"]
        : "";
      modalSubmitData[index].originalSeason = product[
        this.docPrefix + "_originalAssetsSeasonLabel"
      ]
        ? product[this.docPrefix + "_originalAssetsSeasonLabel"]
        : "";
      modalSubmitData[index].retailerSKU = product[this.docPrefix + "_sku"]
        ? product[this.docPrefix + "_sku"]
        : "";
      modalSubmitData[index].UPC = product[this.docPrefix + "_upc"]
        ? product[this.docPrefix + "_upc"]
        : "";
      modalSubmitData[index].originalAssetSeasonID = product[
        this.docPrefix + "_originalAssetSeason"
      ]
        ? product[this.docPrefix + "_originalAssetSeason"]
        : null;
      modalSubmitData[index].onShelfDate =
        product[this.docPrefix + "_inMarketDate"];
      modalSubmitData[index].originalAssetsUID =
        product[this.docPrefix + "_originalAssets"];
      modalSubmitData[index].isSoldInPackage =
        product[this.docPrefix + "_isSoldInPackage"];
      modalSubmitData[index].isSoldInSet =
        product[this.docPrefix + "_isSoldInSet"];
      modalSubmitData[index].isDigitalContent =
        product[this.docPrefix + "_isDigitalContent"];
      modalSubmitData[index].isPlush = product[this.docPrefix + "_isPlush"];
      modalSubmitData[index].pricePointUSD =
        product[this.docPrefix + "_pricePoint"];
      modalSubmitData[index].item = product["gte_item"]
        ? product["gte_item"]
        : "";
      modalSubmitData[index].itemType = product["gte_itemTypeGTE"]
        ? product["gte_itemTypeGTE"]
        : "";
    });

    this.setState({
      tierOfDistribution: jobInfo["submission:tierOfDistribution"],
      retailer: jobInfo["submission:retailer"],
      consumerTarget: jobInfo["submission:consumerTarget"],
      onShelfDate: jobInfo["submission:inMarketDate"],
      productTitle: jobInfo["dc:description"] ? jobInfo["dc:description"] : "",
      lineSheetRef: jobInfo["submission:internalRefId"]
        ? jobInfo["submission:internalRefId"]
        : "",
      additionalNotes: jobInfo["submission:notes"]
        ? jobInfo["submission:notes"]
        : "",
      season: jobInfo["submission:inMarketSeason"],
      submissionType: jobInfo["gte_submission:submissionTypeGTE"],
      submissionNumber: jobInfo["gte_submission:marketGoodNumber"],
      targetAudience: jobInfo["gte_submission:targetAudience"]
        ? jobInfo["gte_submission:targetAudience"]
        : "",
      deliveryType: jobInfo["gte_submission:deliveryTypeMkg"],
      inMarketStartDate: jobInfo["gte_submission:programBegin"],
      inMarketEndDate: jobInfo["gte_submission:programEnd"],
    });

    setTimeout(() => {
      this.setState({
        modalSubmitData,
        isJobInfoLoading: false,
      });
    }, 5000);
  }

  async _getInfoById(id, index = null) {
    var response;

    await NuxeoClient.instance()
      .getJobInfo(id)
      .then((res) => {
        response = res;
      });
    response.index = index;

    return response;
  }

  async _createEmptyDoc() {
    await NuxeoClient.instance()
      .fetchDocument(this.docType)
      .then((response) => {
        this.document = response;
      });
  }

  async _loadItemType() {
    await NuxeoClient.instance()
      .fetchItemType()
      .then((response) => {
        this.setState({ fetchedItemType: response });
      });
  }

  async _loadLocations() {
    await NuxeoClient.instance()
      .fetchLocations()
      .then((response) => {
        this.setState({
          fetchedLocations: response.entries,
          areLocationsLoading: false,
        });
      });
  }

  async _loadAreas() {
    await NuxeoClient.instance()
      .fetchAreas()
      .then((response) => {
        this.setState({
          fetchedAreas: response.entries,
          areAreasLoading: false,
        });
      });
  }

  async _loadAttractions() {
    await NuxeoClient.instance()
      .fetchAttractions()
      .then((response) => {
        this.setState({
          fetchedAttractions: response.entries,
          areAttractionsLoading: false,
        });
      });
  }

  handleCancel() {
    window.location.href = "/#!/home";
  }

  handleChange = (name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => this._checkFieldChange(name, value)
    );
  };

  clearValues() {
    this.setState({
      contract: "",
      territories: [],
      property: null,
      submissionType: "",
      location: [],
      area: [],
      attraction: [],
      submissionNumber: "",
      consumerTarget: [],
      lineSheetFiles: "",
      lineSheetFilesBatch: [],
      productTitle: "",
      additionalNotes: "",
      associatedJobs: [],
      lineSheetRef: "",
      modalSubmitData: [],
    });
  }

  _checkFieldChange(name, value) {
    if (name === "licenseeCode") {
      this.clearValues();
    }

    if (name === "contractID") {
      if (!this.state.isJobInfoLoading) {
        this.setState({
          territories: [],
          property: "",
          productDetail: null,
          productDetailID: null,
          originalAssetsUID: [],
          originalAssetsParentRef: [],
          characters: [],
          charactersID: [],
        });
      }
    }

    if (name === "propertyID") {
      this.setState({
        originalAssetsUID: [],
        originalAssetsParentRef: [],
        characters: [],
        charactersID: [],
        fetchedAssetFileCharacters: [],
      });
    }

    if (name === "submissionType" && value !== "Marketing & PR") {
      this.setState({
        deliveryType: "",
        inMarketEndDate: null,
        inMarketStartDate: null,
        targetAudience: "",
      });
    }

    if (name === "licenseeRef")
      this.setState({
        retailerSKU: this.state.licenseeRef,
      });
  }

  handleRemoveFile(name, file) {
    if (name === "supportingFiles") {
      let supportingFilesBatch = [...this.state.supportingFilesBatch];
      supportingFilesBatch = supportingFilesBatch.filter(
        (data) => data !== file
      );
      this.setState({ supportingFilesBatch });
    } else if (name === "lineSheetFiles") {
      this.setState({
        [name]: [],
        [name + "Batch"]: null,
      });
    } else {
      this.setState({
        [name]: [],
        [name + "Batch"]: null,
      });
    }
  }

  //Saving files to state for further use and closing Modal.
  async handleSave(name, newFiles, isLast = false) {
    if (name === "files") {
      this.setState({ areFilesUploading: true });
    }
    if (name === "supportingFiles") {
      this.setState({ areSupportingFilesUploading: true });
    }
    if (name === "lineSheetFiles") {
      this.setState({ areLineSheetFilesUploading: true });
    }

    await NuxeoClient.instance()
      .getBatchID()
      .then((response) => {
        NuxeoClient.instance()
          .uploadFiles(newFiles, response.batchId)
          .then((response) => {
            NuxeoClient.instance()
              .getFileInfo(response.batchId)
              .then((response) => {
                if (response.code !== "201") {
                  if (name === "files") {
                    this.setState({ areFilesUploading: false });
                  }
                  if (name === "supportingFiles" && isLast === true) {
                    this.setState({ areSupportingFilesUploading: false });
                  }
                  if (name === "lineSheetFiles") {
                    this.setState({ areLineSheetFilesUploading: false });
                  }
                }
                let fileObj = {
                  name: response.fileEntries[0].name,
                  "upload-batch": response.batchId,
                  "upload-fileId": "0",
                };

                if (name === "supportingFiles") {
                  let supportingFilesBatch = [
                    ...this.state.supportingFilesBatch,
                  ];
                  supportingFilesBatch.push(fileObj);
                  this.setState({ supportingFilesBatch });
                } else if (name === "files") {
                  this.setState({ filesBatch: fileObj });
                } else if (name === "lineSheetFiles") {
                  var lsArray = [];
                  lsArray.push(fileObj);
                  this.setState({ lineSheetFilesBatch: lsArray });
                }
              });
          });
      });
    this.setState({
      [name]: newFiles,
      [name + "Open"]: false,
    });
  }

  handleCheckboxChange = (name) => {
    let value = !this.state[name];
    this.setState({
      [name]: value,
    });
  };

  onCloseModal = () => {
    this.setState({
      modalOpened: false,
      resetModal: true,
      editModal: false,
      areFilesUploading: false,
      areSupportingFilesUploading: false,
    });
  };

  editRow = (index) => {
    const data = this.state.modalSubmitData[index];

    this.setState({
      editData: data,
      editIndex: index,
      licenseeRef: data.licenseeRef,
      productDetail: data.productDetail,
      productDetailID: data.productDetailID,
      originalSeason: data.originalSeason,
      assetFileName: data.assetFileName,
      originalAssetsUID: data.originalAssetsUID,
      originalAssetsParentRef: data.originalAssetsParentRef,
      retailerSKU: data.retailerSKU,
      UPC: data.UPC,
      onShelfDate: data.onShelfDate,
      characters: data.characters,
      charactersID: data.charactersID,
      isDigitalContent: data.isDigitalContent,
      isPlush: data.isPlush,
      isSoldInPackage: data.isSoldInPackage,
      isSoldInSet: data.isSoldInSet,
      locationProduct: data.location,
      attractionProduct: data.attraction,
      item: data.item,
      itemType: data.itemType,
      areaProduct: data.area,
      text: data.text_verbiage,
      pricePointUSD: data.pricePointUSD,
      filesBatch: data.filesBatch,
      files: data.files,
      supportingFilesBatch: data.supportingFilesBatch,
      modalOpened: true,
      resetModal: false,
      editModal: true,
    });
  };

  deleteRow = (index) => {
    var data = this.state.modalSubmitData[index];
    const modalSubmitData = this.state.modalSubmitData.filter(
      (item) => item !== data
    );

    this.setState({
      modalSubmitData,
    });
  };

  getModalSubmitData = () => {
    const data = {
      licenseeRef: this.state.licenseeRef,
      productDetail: this.state.productDetail,
      productDetailID: this.state.productDetailID,
      originalSeason: this.state.originalSeason,
      originalAssetSeasonID: this.state.originalAssetSeasonID,
      assetFileName: this.state.assetFileName,
      originalAssetsParentRef: this.state.originalAssetsParentRef,
      originalAssetsUID: this.state.originalAssetsUID,
      retailerSKU: this.state.retailerSKU,
      UPC: this.state.UPC,
      onShelfDate: this.state.onShelfDate
        ? ArrayUtils.convertToISO(this.state.onShelfDate)
        : "",
      characters: this.state.characters,
      charactersID: this.state.charactersID,
      text_verbiage: this.state.text,
      location: this.state.locationProduct,
      item: this.state.item,
      itemType: this.state.itemType,
      area: this.state.areaProduct,
      attraction: this.state.attractionProduct,
      isSoldInPackage: this.state.isSoldInPackage,
      isSoldInSet: this.state.isSoldInSet,
      isPlush: this.state.isPlush,
      isDigitalContent: this.state.isDigitalContent,
      pricePointUSD: this.state.pricePointUSD,
      filesBatch: this.state.filesBatch,
      files: this.state.files,
      supportingFilesBatch: this.state.supportingFilesBatch,
    };
    return data;
  };

  handleSubmitModal = () => {
    var regex = /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/;

    if (this.state.pricePointUSD !== null && this.state.pricePointUSD !== "") {
      if (this.state.pricePointUSD.toString().match(regex) === null) {
        this.setState({
          openSnackMsg: true,
          snackBarMsg: "Price point should be a numeric value",
        });
        return false;
      }
    }

    let modalSubmitData = [...this.state.modalSubmitData];

    if (this.state.editModal) {
      modalSubmitData = modalSubmitData.filter(
        (data) => data !== this.state.editData
      );
    }

    modalSubmitData.push(this.getModalSubmitData());

    this.setState({
      modalSubmitData,
      modalOpened: false,
      editModal: false,
      resetModal: true,
    });
  };

  checkFiles() {
    var designMissing = false;

    this.state.modalSubmitData.forEach((data) => {
      if (data.filesBatch === null || data.filesBatch === "") {
        designMissing = true;
      }
    });

    if (designMissing) {
      this.setState({
        openSnackMsg: true,
        snackBarMsg: `Please, use pencil icon to upload your design from the Add Item`,
      });
      return false;
    } else return true;
  }

  async handleSubmit() {
    if (!this.checkFiles()) {
      return false;
    }

    window.scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
    this.setState({ isSubmitting: true });

    var submitData = {
      licenseeName: this.state.licensee,
      contract: this.state.contract,
      territories: this.state.territories,
      property: this.state.property,
      submissionType: this.state.submissionType,
      location: this.state.location,
      area: this.state.area,
      attraction: this.state.attraction,
      consumerTarget: this.state.consumerTarget,
      productTitle: this.state.productTitle,
      additionalNotes: this.state.additionalNotes,
      associatedJobs: this.state.associatedJobs,
      associatedJobsID: this.state.associatedJobsID,
      licenseeRef: this.state.licenseeRef,
      productDetail: this.state.productDetail,
      assetFileName: this.state.assetFileName,
      characters: this.state.characters,
      item: this.state.item,
      lineSheetFiles:
        this.state.lineSheetFilesBatch.length > 0
          ? this.state.lineSheetFilesBatch[0]
          : null,
      itemType: this.state.itemType,
      text: this.state.text,
      pricePointUSD: this.state.pricePointUSD,
      isSoldInPackage: this.state.isSoldInPackage,
      isSoldInSet: this.state.isSoldInSet,
      isDigitalContent: this.state.isDigitalContent,
      isPlush: this.state.isPlush,
      lineSheetRef: this.state.lineSheetRef,
      submissionNumber: this.state.submissionNumber,
      targetAudience: this.state.targetAudience,
      deliveryTypeMkg: this.state.deliveryType,
      isFavorite: this.state.isFavorite,
      favoriteName: this.state.favoriteName,
      programBegin: this.state.inMarketStartDate
        ? ArrayUtils.convertToISO(this.state.inMarketStartDate)
        : "",
      programEnd: this.state.inMarketEndDate
        ? ArrayUtils.convertToISO(this.state.inMarketEndDate)
        : "",
    };

    let productsArray = [];

    let locationUID = [];
    let areaUID = [];
    let attractionsUID = [];

    if (Array.isArray(this.state.location)) {
      this.state.location.forEach((item) => {
        this.state.fetchedLocations.forEach((data) => {
          if (data.title === item) {
            locationUID.push(data.uid);
          }
        });
      });
    }

    if (Array.isArray(this.state.area)) {
      this.state.area.forEach((item) => {
        this.state.fetchedAreas.forEach((data) => {
          if (data.title === item) {
            areaUID.push(data.uid);
          }
        });
      });
    }

    if (Array.isArray(this.state.attraction)) {
      this.state.attraction.forEach((item) => {
        this.state.fetchedAttractions.forEach((data) => {
          if (data.title === item) {
            attractionsUID.push(data.uid);
          }
        });
      });
    }

    this.state.modalSubmitData.forEach((item) => {
      let locationUIDLS = [];
      let areaUIDLS = [];
      let attractionUIDLS = [];

      let files = [];
      files.push(item.filesBatch);
      item.supportingFilesBatch.map((file) => files.push(file));

      if (Array.isArray(item.location)) {
        item.location.forEach((locationItem) => {
          this.state.fetchedLocations.forEach((data) => {
            if (data.title === locationItem) {
              locationUIDLS.push(data.uid);
            }
          });
        });
      }

      if (Array.isArray(item.area)) {
        item.area.forEach((areaItem) => {
          this.state.fetchedAreas.forEach((data) => {
            if (data.title === areaItem) {
              areaUIDLS.push(data.uid);
            }
          });
        });
      }

      if (Array.isArray(item.attraction)) {
        item.attraction.forEach((attractionItem) => {
          this.state.fetchedAttractions.forEach((data) => {
            if (data.title === attractionItem) {
              attractionUIDLS.push(data.uid);
            }
          });
        });
      }

      let product = {
        // contractId: contractUID,
        contractProps: this.state.propertyID,
        gte_sku: item.retailerSKU === "" ? null : item.retailerSKU,
        gte_upc: item.UPC === "" ? null : item.UPC,
        gte_assetTextVerbiage: item.text_verbiage,
        gte_characters: item.charactersID,
        gte_charactersLabel: item.characters,
        gte_files: files,
        gte_internalRefId: item.licenseeRef === "" ? null : item.licenseeRef,
        gte_originalAssets: item.originalAssetsUID,
        gte_originalAssetsLabel: item.assetFileName,
        gte_originalAssetsParentRef: item.originalAssetsParentRef,
        gte_productDetail: item.productDetailID,
        gte_productDetailLabel: [item.productDetail],
        gte_pricePoint: item.pricePointUSD,
        gte_isSoldInPackage: item.isSoldInPackage,
        gte_isSoldInSet: item.isSoldInSet,
        gte_isDigitalContent: item.isDigitalContent,
        gte_isPlush: item.isPlush,
        gte_itemTypeGTE: item.itemType ? item.itemType : null,
        gte_itemTypeLabel: item.itemType,
        gte_item: item.item,
        property: this.state.propertyID,
        propertyName: [submitData.property],
        submissionType: submitData.submissionType,
        gte_location: locationUIDLS,
        gte_locationLabel: item.location,
        gte_area: areaUIDLS.length === 0 ? null : areaUIDLS,
        gte_areaLabel: item.area.length === 0 ? null : item.area,
        gte_attraction: attractionUIDLS.length === 0 ? null : attractionUIDLS,
        gte_attractionLabel:
          item.attraction.length === 0 ? null : item.attraction,
        gte_inMarketDate: item.onShelfDate,
        gte_originalAssetsSeason: item.originalAssetSeasonID,
        gte_originalAssetsSeasonLabel:
          item.originalSeason !== "" ? [item.originalSeason] : [],
      };

      productsArray.push(product);
    });

    //update document
    this.document.properties["dc:description"] =
      submitData.productTitle === "" ? null : submitData.productTitle;
    this.document.properties["dc:title"] = submitData.contract;
    this.document.properties[this.docPrefix + "_submission:product"] =
      productsArray;
    this.document.properties["gte_submission:submissionTypeGTE"] =
      submitData.submissionType;
    this.document.properties["gte_submission:location"] =
      locationUID.length === 0 ? null : locationUID;
    this.document.properties["gte_submission:area"] =
      areaUID.length === 0 ? null : areaUID;
    this.document.properties["gte_submission:attraction"] =
      attractionsUID.length === 0 ? null : attractionsUID;
    this.document.properties["gte_submission:linesheet"] =
      submitData.lineSheetFiles;
    this.document.properties["gte_submission:marketGoodNumber"] =
      submitData.submissionNumber;
    this.document.properties["gte_submission:targetAudience"] =
      submitData.targetAudience;
    this.document.properties["gte_submission:deliveryTypeMkg"] =
      submitData.deliveryTypeMkg ? submitData.deliveryTypeMkg : null;
    this.document.properties["gte_submission:programBegin"] =
      submitData.programBegin;
    this.document.properties["gte_submission:programEnd"] =
      submitData.programEnd;
    this.document.properties["submission:associatedJobs"] =
      submitData.associatedJobsID;
    this.document.properties["submission:consumerTarget"] =
      submitData.consumerTarget;
    this.document.properties["submission:contract"] = this.state.contractID;
    this.document.properties["submission:internalRefId"] =
      submitData.lineSheetRef === "" ? null : submitData.lineSheetRef;
    this.document.properties["submission:licensee"] = this.state.licenseeID;
    this.document.properties["submission:notes"] =
      submitData.additionalNotes === "" ? null : submitData.additionalNotes;
    this.document.properties["submission:property"] = this.state.propertyID;
    this.document.properties["submission:propertyName"] = submitData.property;
    this.document.properties["submission:territories"] =
      this.state.territoriesID;
    this.document.properties["submission:isFavorite"] = submitData.isFavorite;
    this.document.properties["submission:favoriteName"] =
      this.state.favoriteName;

    let products =
      this.document.properties[this.docPrefix + "_submission:product"];
    let productsOld = JSON.parse(JSON.stringify(products));

    this.document.name =
      this.document.name ||
      StringUtils._sanitizeName(this.document.properties["dc:title"]);
    let documentEnrichmentParams = {
      documentProperties: JSON.stringify(this.document.properties),
      docPrefix: this.docPrefix,
      propertyName: this.document.properties["submission:propertyName"],
      parentRef: this.state.licenseeID,
    };
    this.docPath =
      "/default-domain/workspaces/Submission/" + this.state.licensee;
    NuxeoClient.instance()
      .documentEnrichment(documentEnrichmentParams)
      .then((res) => {
        this.document.properties = res;
        this.document = JSON.parse(CircularJSON.stringify(this.document));
        NuxeoClient.instance()
          .submitDocument(this.docPath, this.document)
          .then((responseDoc) => {
            const jobId =
              this.document.properties["submission:workfrontProjectId"];
            ReactGA.event({
              category: "Form",
              action: "Form Submit",
              transport: "beacon",
              label: `GTE Submitted - ${this.state.property}`,
            });
            window.history.pushState({}, null, `/submit/gte?${jobId}`);
            EventUtils.raiseEvent("success", { jobId: jobId }, this.props);
          });
      })
      .catch((error) => {
        this.document.properties[this.docPrefix + "_submission:product"] =
          productsOld;
        console.log("Error in DocumentEnrichment parsing: " + error);
        ReactGA.event({
          category: "Form",
          action: "Form Submit Error",
          transport: "beacon",
          label: `GTE Form Error - ${error}`,
        });
        alert("Failed to submit job.");

        //submit progress indicator show
        this.setState({ isSubmitting: false });
      });
  }

  checkRequiredFields = () => {
    for (var item of this.state.requiredFields) {
      if (
        this.state[item] === null ||
        this.state[item] === "" ||
        (typeof this.state[item] === "object" && this.state[item].length === 0)
      ) {
        if (
          item === "deliveryType" ||
          item === "targetAudience" ||
          item === "inMarketStartDate" ||
          item === "inMarketEndDate"
        ) {
          if (this.state.submissionType === "Marketing & PR") {
            if (item === "inMarketStartDate") {
              this.setState({
                openSnackMsg: true,
                snackBarMsg: "Program begin date is required to proceed",
              });
            } else if (item === "inMarketEndDate") {
              this.setState({
                openSnackMsg: true,
                snackBarMsg: "Program end date is required to proceed",
              });
            } else {
              item = item.replace(/([A-Z])/g, " $1").trim();
              item = item[0].toUpperCase() + item.slice(1);
              this.setState({
                openSnackMsg: true,
                snackBarMsg: `${item} is required to proceed`,
              });
            }
          }
        } else if (item === "files") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: "Upload any one design file is required to proceed",
          });
        } else if (item === "modalSubmitData") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: "Add at least one product to proceed",
          });
        } else {
          item = item.replace(/([A-Z])/g, " $1").trim();
          item = item[0].toUpperCase() + item.slice(1);
          this.setState({
            openSnackMsg: true,
            snackBarMsg: `${item} is required to proceed`,
          });
        }
        return false;
      }
    }
  };

  render() {
    const appText = this.context;
    return (
      <div className="marketing-form-container">
        <Fade in={true} timeout={500}>
          <Grid
            container={true}
            direction="column"
            spacing={4}
            alignItems="stretch"
            className="form-wrapper"
          >
            <Grid item={true} xs={12} style={{ paddingBottom: 0 }}>
              <div id="header-with-fav">
                {/* <h5 className="form-heading">Themed Entertainment</h5> */}
                <h5 className="form-heading">{appText.T11}</h5>
                <FavMenu
                  setJobInfo={this.setJobInfo}
                  licensee={this.state.licensee}
                  licenseePath={this.state.licenseePath}
                  docType={this.docType}
                  user={this.props.user}
                  handleChange={this.handleChange}
                />
              </div>
            </Grid>

            <JobLoadingModal isJobInfoLoading={this.state.isJobInfoLoading} />

            <Licensee
              handleChange={this.handleChange}
              value={this.state.licensee}
              fetchedData={this.state.fetchedLicensees}
            />

            <Contract
              value={this.state.contract}
              handleChange={this.handleChange}
              fetchedData={this.state.fetchedContracts}
              licenseeCode={this.state.licenseeCode}
            />

            {this.state.contract ? (
              <Territories
                value={this.state.territories}
                id={this.state.territoriesID}
                handleChange={this.handleChange}
                contractID={this.state.contractID}
              />
            ) : null}

            {this.state.contract ? (
              <Property
                value={this.state.property}
                fetchedData={this.state.fetchedProperty}
                handleChange={this.handleChange}
                contractID={this.state.contractID}
              />
            ) : null}

            <SubmissionType
              handleChange={this.handleChange}
              value={this.state.submissionType}
            />

            {this.state.submissionType === "Marketing & PR" ? (
              <DeliveryType
                value={this.state.deliveryType}
                submissionType={this.state.submissionType}
                handleChange={this.handleChange}
              />
            ) : null}

            {this.state.submissionType === "Marketing & PR" ? (
              <Text
                // inputName="Target Audience"
                inputName={appText.T842}
                value={this.state.targetAudience}
                field="targetAudience"
                isRequired={true}
                message={appText.T847}
                handleChange={this.handleChange}
              />
            ) : null}

            {this.state.submissionType === "Marketing & PR" ? (
              <Date
                // title={"Program Begins"}
                title={appText.T843}
                field={"inMarketStartDate"}
                // message={"Please enter the date the program beigns"}
                message={appText.T845}
                isRequired={true}
                handleChange={this.handleChange}
                value={this.state.inMarketStartDate}
              />
            ) : null}

            {this.state.submissionType === "Marketing & PR" ? (
              <Date
                // title={"Program Ends"}
                title={appText.T844}
                field={"inMarketEndDate"}
                isRequired={true}
                message={appText.T848}
                handleChange={this.handleChange}
                value={this.state.inMarketEndDate}
              />
            ) : null}

            {/* <Tooltip arrow title="Please select the location"> */}
            <Tooltip arrow title={appText.T405}>
              <Grid item={true} xs={12}>
                <div id="location">
                  <InputLabel className="field-label field-dropdown" required>
                    {/* Location */}
                    {appText.T345}
                  </InputLabel>
                  <Autocomplete
                    type={"multi"}
                    handleChange={this.handleChange}
                    data={this.state.fetchedLocations}
                    dataType={"location"}
                    mapVariable={"title"}
                    value={this.state.location}
                    setFilterData={() => {}}
                    isLoading={this.state.areLocationsLoading}
                  />
                </div>
              </Grid>
            </Tooltip>

            {/* <Tooltip arrow title="Please select the area"> */}
            <Tooltip arrow title={appText.T406}>
              <Grid item={true} xs={12}>
                <div id="area">
                  <InputLabel className="field-label field-dropdown">
                    {/* Area */}
                    {appText.T346}
                  </InputLabel>
                  <Autocomplete
                    type={"multi"}
                    handleChange={this.handleChange}
                    data={this.state.fetchedAreas}
                    dataType={"area"}
                    mapVariable={"title"}
                    value={this.state.area}
                    setFilterData={() => null}
                    isLoading={this.state.areAreasLoading}
                  />
                </div>
              </Grid>
            </Tooltip>

            {/* <Tooltip arrow title="Please select the attraction"> */}
            <Tooltip arrow title={appText.T407}>
              <Grid item={true} xs={12}>
                <div id="attraction">
                  <InputLabel className="field-label field-dropdown">
                    {/* Attraction */}
                    {appText.T347}
                  </InputLabel>
                  <Autocomplete
                    type={"multi"}
                    handleChange={this.handleChange}
                    data={this.state.fetchedAttractions}
                    dataType={"attraction"}
                    mapVariable={"title"}
                    value={this.state.attraction}
                    setFilterData={() => null}
                    isLoading={this.state.areAttractionsLoading}
                  />
                </div>
              </Grid>
            </Tooltip>

            {/* <Tooltip arrow title="enter submission number"> */}
            <Tooltip arrow title={appText.T408}>
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text">
                  {/* Licensed Product Submission Number */}
                  {appText.T348}
                </InputLabel>
                <TextField
                  style={{ marginTop: 5, fontSize: 15, height: 30 }}
                  aria-label="minimum height"
                  rows={1}
                  fullWidth={true}
                  value={this.state.submissionNumber}
                  className="textArea-field"
                  onChange={(event) =>
                    this.handleChange("submissionNumber", event.target.value)
                  }
                />
              </Grid>
            </Tooltip>

            <ConsumerTarget
              handleChange={this.handleChange}
              value={this.state.consumerTarget}
            />

            <Text
              // inputName="Project Description"
              inputName={appText.T62}
              value={this.state.productTitle}
              field="productTitle"
              // message={CommonContants.PROJECT_DESCRIPTION_MESSAGE}
              message={appText.T123}
              handleChange={this.handleChange}
            />

            <Text
              // inputName="Linesheet Reference #"
              inputName={appText.T63}
              value={this.state.lineSheetRef}
              field="lineSheetRef"
              // message={CommonContants.LS_REF_MESSSAGE}
              message={appText.T124}
              handleChange={this.handleChange}
            />

            <Text
              // inputName="Notes for BA Representative"
              inputName={appText.T64}
              value={this.state.additionalNotes}
              field="additionalNotes"
              // message={CommonContants.NOTES_MESSAGE}
              message={appText.T125}
              handleChange={this.handleChange}
            />

            <AssociatedJobs
              handleChange={this.handleChange}
              value={this.state.associatedJobs}
              id={this.state.associatedJobsID}
            />

            <LineSheet
              isUploading={this.state.areLineSheetFilesUploading}
              handleSave={this.handleSave}
              handleRemoveFile={this.handleRemoveFile}
              lineSheetFilesBatch={this.state.lineSheetFilesBatch}
            />

            <Grid item={true} xs={12}>
              <Button
                variant="outlined"
                disabled={this.state.property ? false : true}
                onClick={() => this.handleChange("modalOpened", true)}
                style={{ width: "100%", fontSize: "1rem" }}
              >
                {/* +Add Item */}
                {appText.T357}
              </Button>

              <div id="header-legal-line">
                <h8 className="legal-line">
                  {/* Please ensure legal line is visible on submission. */}
                  {appText.T77}
                </h8>
              </div>

              {this.state.modalOpened === true ? (
                <AddProductModal
                  resetData={this.state.resetModal}
                  edit={this.state.editModal}
                  type={"gte"}
                  data={this.state}
                  handleChange={this.handleChange}
                  handelChangeAutocomplete={this.handleChange}
                  handleMultipleChange={this.handleChange}
                  handleDelete={this.handleDelete}
                  handleCheckboxChange={this.handleCheckboxChange}
                  handleSave={this.handleSave}
                  handleClose={this.handleClose}
                  handleRemoveFile={this.handleRemoveFile}
                  onCloseModal={this.onCloseModal}
                  handleSubmitModal={this.handleSubmitModal}
                  handleOpenModal={this.handleOpenModal}
                />
              ) : (
                <div></div>
              )}
            </Grid>

            <Table
              modalSubmitData={this.state.modalSubmitData}
              editRow={this.editRow}
              deleteRow={this.deleteRow}
            />

            <Grid item={true} xs={12}>
              {this.state.submissionType === "Marketing & PR" ? (
                this.state.licensee &&
                this.state.contract &&
                this.state.property &&
                this.state.territories.length > 0 &&
                this.state.submissionType &&
                this.state.location.length > 0 &&
                this.state.consumerTarget.length > 0 &&
                this.state.modalSubmitData.length > 0 &&
                this.state.deliveryType &&
                this.state.targetAudience &&
                this.state.inMarketEndDate &&
                this.state.inMarketStartDate ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="btn"
                      onClick={this.handleCancel}
                      type="submit"
                      value="Cancel"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      className="btn"
                      onClick={this.handleSubmit}
                      type="submit"
                      value="Submit"
                    >
                      Submit
                    </Button>{" "}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="btn"
                      onClick={this.handleCancel}
                      type="submit"
                      value="Cancel"
                    >
                      {/* Cancel */}
                      {appText.T104}
                    </Button>
                    <span
                      onClick={this.checkRequiredFields}
                      style={{
                        display: "inline-block",
                        width: "auto",
                      }}
                    >
                      <Button
                        variant="outlined"
                        className="btn"
                        disabled
                        onClick={this.handleSubmit}
                        type="submit"
                        value="Submit"
                      >
                        {/* Submit */}
                        {appText.T113}
                      </Button>
                    </span>
                  </div>
                )
              ) : this.state.licensee &&
                this.state.contract &&
                this.state.property &&
                this.state.territories.length > 0 &&
                this.state.submissionType &&
                this.state.location.length > 0 &&
                this.state.consumerTarget.length > 0 &&
                this.state.modalSubmitData.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleCancel}
                    type="submit"
                    value="Cancel"
                  >
                    {/* Cancel */}
                    {appText.T104}
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleSubmit}
                    type="submit"
                    value="Submit"
                  >
                    {/* Submit */}
                    {appText.T113}
                  </Button>{" "}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleCancel}
                    type="submit"
                    value="Cancel"
                  >
                    {/* Cancel */}
                    {appText.T104}
                  </Button>
                  <span
                    onClick={this.checkRequiredFields}
                    style={{
                      display: "inline-block",
                      width: "auto",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="btn"
                      disabled
                      onClick={this.handleSubmit}
                      type="submit"
                      value="Submit"
                    >
                      {/* Submit */}
                      {appText.T113}
                    </Button>
                  </span>
                </div>
              )}
            </Grid>

            <Loading hidden={!this.state.isSubmitting}></Loading>
            <SnackBar
              isOpen={this.state.openSnackMsg}
              snackBarMsg={this.state.snackBarMsg}
              handleChange={this.handleChange}
            />
          </Grid>
        </Fade>
      </div>
    );
  }
}

export default GTESubmissionFields;
